/* KILUKRU — Limite 1 exemplaire par ebook dans le panier.
   Si une ligne de type produit "ebook" dépasse 1, on la ramène à 1. */
(function () {
  var busy = false;

  function cap() {
    if (busy) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var found = false;
        (cart.items || []).forEach(function (it) {
          if (it.product_type === 'ebook' && it.quantity > 1) {
            updates[it.key] = 1;
            found = true;
          }
        });
        if (!found) return;
        busy = true;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          // recharge l'UI panier (page ou drawer) proprement
          window.location.reload();
        });
      })
      .catch(function () { busy = false; });
  }

  if (document.readyState !== 'loading') cap();
  else document.addEventListener('DOMContentLoaded', cap);

  // Re-vérifie quand le panier change (ajout via drawer/notification)
  ['cart:updated', 'cart:refresh'].forEach(function (evt) {
    document.addEventListener(evt, cap);
  });
  document.addEventListener('cart:build', cap);

  // Filet : observe les conteneurs panier qui se re-rendent
  ['#CartDrawer-CartItems', '#main-cart-items', 'cart-notification', 'cart-drawer'].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el && window.MutationObserver) {
      new MutationObserver(function () { cap(); }).observe(el, { childList: true, subtree: true });
    }
  });
})();
